import { LocalDate } from '../../../core/model/local-date';
import { ModelBase } from '../../../core/model/model-base';
import { RentInvoicingOrderSettings } from './rent-invoicing-order-settings';

export class RentInvoicingOrderUpdateModel extends ModelBase {
  caption: string;
  dueFrom: LocalDate;
  dueTo: LocalDate;
  settings: RentInvoicingOrderSettings;
  retry: boolean;
}
